import { render, staticRenderFns } from "./index-material.vue?vue&type=template&id=0762a8c0"
import script from "./index-material.vue?vue&type=script&lang=js"
export * from "./index-material.vue?vue&type=script&lang=js"
import style0 from "./index-material.vue?vue&type=style&index=0&id=0762a8c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports